var _rect, _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowsLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-1388 -984C-1388 -985.105 -1387.1 -986 -1386 -986H6810C6811.1 -986 6812 -985.105 6812 -984V2137C6812 2138.1 6811.1 2139 6810 2139H-1386C-1387.1 2139 -1388 2138.1 -1388 2137V-984Z",
    fill: "#6A62B7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-1386 -985H6810V-987H-1386V-985ZM6811 -984V2137H6813V-984H6811ZM6810 2138H-1386V2140H6810V2138ZM-1387 2137V-984H-1389V2137H-1387ZM-1386 2138C-1386.55 2138 -1387 2137.55 -1387 2137H-1389C-1389 2138.66 -1387.66 2140 -1386 2140V2138ZM6811 2137C6811 2137.55 6810.55 2138 6810 2138V2140C6811.66 2140 6813 2138.66 6813 2137H6811ZM6810 -985C6810.55 -985 6811 -984.552 6811 -984H6813C6813 -985.657 6811.66 -987 6810 -987V-985ZM-1386 -987C-1387.66 -987 -1389 -985.657 -1389 -984H-1387C-1387 -984.552 -1386.55 -985 -1386 -985V-987Z",
    fill: "black",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_31_756)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 2573,
    transform: "translate(-1188 -786)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: 0.5,
    width: 55,
    height: 55,
    rx: 27.5,
    transform: "matrix(-1 0 0 1 55 0)",
    stroke: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2929 28.7071C14.9024 28.3166 14.9024 27.6834 15.2929 27.2929L21.6569 20.9289C22.0474 20.5384 22.6805 20.5384 23.0711 20.9289C23.4616 21.3195 23.4616 21.9526 23.0711 22.3431L17.4142 28L23.0711 33.6569C23.4616 34.0474 23.4616 34.6805 23.0711 35.0711C22.6805 35.4616 22.0474 35.4616 21.6569 35.0711L15.2929 28.7071ZM40 29H16V27H40V29Z",
    fill: "#141414"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_31_756"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 2573,
    fill: "white",
    transform: "translate(-1188 -786)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowsLeft);
export default __webpack_public_path__ + "static/media/arrows-left.71fcd414f5187e77c7c244a328a6dbbb.svg";
export { ForwardRef as ReactComponent };